module.exports = [
  {
    "AgeGroup": "55-64 years",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 1282.93
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 1182.83
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 1104.77
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 1007.4
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 1010.03
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 1029.53
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 1018.7
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 989.9
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 929.73
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 882.17
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 858.57
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 854.53
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 876.47
  },
  {
    "AgeGroup": "55-64 years",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 886.25
  }
]
